import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide,
    Typography,
  } from "@mui/material";
  import { Stack } from "@mui/material";
  import React, { useContext, useState } from "react";
import { ThemeContext } from "../theme/ThemeContext";
  
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  
  
  function Theme({ open, handleClose }) {
    const { toggleTheme } = useContext(ThemeContext);
   const [mode , setMode]=useState(false);
const handleMode=()=>{
  setMode(!mode);
}
    return (
      <>
        <Dialog
        className="theme"
        variant="contained"
          fullWidth
          maxWidth="sm"
          open={open}
          onClose={handleClose}
          keepMounted
          TransitionComponent={Transition}
          sx={{ p: 4,position:"absolute"}}
        >
          <DialogTitle >Theme</DialogTitle>
          <DialogContent sx={{ mt: 4, }}>
            <Grid container spacing={3} >
              {/*  {list.map(({ key, title, combination }) => ( */}
                <>
                  <Grid /* key={key} */ container item xs={12}>
                    <Stack
                      sx={{ width: "100%" }}
                       
                      justifyContent="center"
                      spacing={3}
                      direction="row"
                      alignItems={"center"}
                    >
                      <Typography variant="caption" sx={{ fontSize: 14 }}>
                        {" "}
                        <Button sx={{bgcolor:"gray"}}  onClickCapture={handleMode} onClick={toggleTheme}>{mode?"Dark Mode":"Light Mode"}</Button>
                      </Typography>
                      <Stack spacing={2} direction="row">
                          {/* {combination.map((el)=>{
                              return<Button disabled variant = "contained" sx={{color:"#212121"}}>{el}</Button>
                          })} */}
                      </Stack>
                    </Stack>
                  </Grid>
                </>
              {/*  ))} */}  
              <Button/>
            </Grid>
          </DialogContent>
          <DialogActions>
              <Button variant="contained" onClick={handleClose}>OK</Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  
  export default Theme;
  